<template>
	<sym-icon :name="name" class="fd-icon-button" :class="{ 'fd-icon-button-disabled': props.disabled }"></sym-icon>
</template>

<script setup lang="ts">
import SymIcon from "./SymIcon.vue";

const props = defineProps({
    disabled: Boolean,
    name: {
        type: String,
        required: true
    }
});

</script>

<style>
.fd-icon-button {
	cursor: pointer;
	min-width: 1.428571428571429em; /* 20px at 14px font */
	color: var(--link-fg);
	user-select: none;
	-webkit-user-select: none;
}

.fd-icon-button:hover {
	color: var(--link-fg-hover);
}

.fd-icon-button:active {
	color: var(--link-fg-active);
}
</style>
